TODO create footer, use for pagnation and stuff